import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { ContactIssuePayload } from "../../types/common";

type Options = {
    onSuccess?: () => void;
    onError?: () => void;
};

export default function useContactIssueMutation(
    options: Options = {},
): UseMutationResult<void, Error, ContactIssuePayload> {
    const { onSuccess, onError } = options;

    return useMutation({
        mutationFn: (payload: ContactIssuePayload): Promise<void> => {
            return salesApiService.postContactIssue(payload);
        },
        onSuccess,
        onError,
        retry: false,
        throwOnError: false,
    });
}
